import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import CardMedia from "@mui/material/CardMedia";
import Rating from "@mui/material/Rating";
import Tooltip from "@mui/material/Tooltip";
import Divider from "@mui/material/Divider";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import SuiBadge from "components/SuiBadge";

import { capitalCase } from "capital-case";
import NumberFormat from "react-number-format";
import { Carousel } from "antd";
import moment from "moment";
import Checkbox from "@mui/material/Checkbox";

import curved9 from "assets/images/upstyled/default_background.png";
import colors from "assets/theme/base/colors";

import CategoryContext from "context/category-context";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";

const CollectionCard = ({
  collection,
  size = "sm",
  detailUrl,
  sx = {},
  handleSelectStyle,
  isSelected,
}) => {
  const seasonLabel = collection?.metadata?.season?.label || "";
  const yearLabel = collection?.metadata?.year
    ? moment(collection?.metadata?.year).format("YYYY")
    : "";
  let products = collection?.products || [];
  const collectionMoodboards = collection?.moodboard || [];
  const primaryImage = collectionMoodboards?.[0]?.img || {};
  const moodboard = collection?.moodboard?.[0] || {};

  const collectionMeta = collection?.metadata || {};
  let styles = {
    cardWidth: 260,
    cardHeight: 425,
    imgHeight: 220,
    titleMinHeight: "34px",
    titleFontSize: "h6",
    textFontSize: "body1",
  };
  if (size == "sm") {
    styles = {
      cardWidth: 220,
      cardHeight: 375,
      imgHeight: 180,
      titleMinHeight: "26px",
      titleFontSize: "h6",
      textFontSize: "body1",
    };
  }

  const ListRow = ({ label, value, divider = false }) => {
    return (
      <SuiBox px={1}>
        <SuiBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{ width: "100%" }}
          gap={1}
        >
          <SuiTypography textTransform="capitalize" sx={{ flex: "none", minWidth: "min-content" }}>
            {label}
          </SuiTypography>
          <SuiBox>
            <Tooltip title={value}>
              <SuiTypography
                color="info"
                textTransform="capitalize"
                lineHeight="1"
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "1",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {value}
              </SuiTypography>
            </Tooltip>
          </SuiBox>
        </SuiBox>
        {divider ? <Divider sx={{ backgroundColor: colors.dark.main, margin: "4px 2px" }} /> : null}
      </SuiBox>
    );
  };
  return (
    <Card
      sx={{
        my: 2,
        mx: 1,
        width: styles.cardWidth,
        minWidth: styles.cardWidth,
        height: styles.cardHeight,
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        borderColor: ({ borders }) => borders.borderColor,
        boxShadow: ({ boxShadows: { md } }) => md,
        ...sx,
      }}
    >
      <SuiBox
        position="relative"
        sx={{ cursor: "pointer", overflow: "hidden", margin: "0 auto" }}
        onClick={handleSelectStyle ? () => handleSelectStyle(!isSelected) : null}
        borderRadius="xl"
        {...(handleSelectStyle
          ? {}
          : { component: detailUrl ? Link : "div", to: detailUrl ? detailUrl : null })}
      >
        <ImageCardWrapper data={primaryImage} height={styles.imgHeight} width={styles.cardWidth} />
      </SuiBox>

      <SuiBox py={1} px={1}>
        <div>
          <SuiBox display="flex" justifyContent="space-between" alignItems="top">
            <Tooltip title={collection.title}>
              <SuiBox
                component={detailUrl ? Link : "div"}
                to={detailUrl ? detailUrl : null}
                sx={{ cursor: "pointer" }}
              >
                <SuiTypography
                  variant={styles.titleFontSize}
                  fontWeight="medium"
                  lineHeight="1.2"
                  sx={{
                    px: 1,
                    minHeight: styles.titleMinHeight,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: "2",
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {collection.title}
                </SuiTypography>
              </SuiBox>
            </Tooltip>
            {handleSelectStyle ? (
              <Checkbox onChange={handleSelectStyle} checked={isSelected} />
            ) : null}
          </SuiBox>

          <ListRow label="Brand" value={collectionMeta?.brand || "N/A"} divider={true} />

          <ListRow label="Season" value={collectionMeta?.season?.label || "N/A"} divider={true} />
          <ListRow
            label="Year"
            value={collectionMeta?.year ? moment(collectionMeta.year).format("YYYY") : "N/A"}
            divider={true}
          />
          <ListRow label="Number of Styles" value={products.length} divider={false} />
        </div>
      </SuiBox>
    </Card>
  );
};

export default CollectionCard;
